import * as Color from 'color'
import { createGlobalStyle } from 'styled-components'
import * as constants from './constants'

const primaryColor = Color(constants.COLORS.primary)

const dayPickerCustomStyle = createGlobalStyle`
  td.CalendarDay,
  .DayPickerNavigation_button {
    border: none !important;
  }

  .DayPicker.DayPicker_1 {
    margin: auto;
    border: solid 1px ${constants.COLORS.divider};
    border-radius: 4px;
  }

  .CalendarMonthGrid {
    background: none;
  }

  .CalendarDay.CalendarDay__selected {
    border-radius: 4px;
  }

  .DateRangePicker.DateRangePicker_1 {
    width: 100%;
  }
  .DateRangePickerInput.DateRangePickerInput_1 {
    display: flex;
    align-items: center;
    width: 100%;
    border: solid 1px ${constants.COLORS.divider};
  }
  .CalendarDay__selected_span {
    background: ${primaryColor.lighten(0.25).hex()};
    border: 1px double ${primaryColor.lighten(0.15).hex()};
    color: #fff;
  }
  .CalendarDay__selected {
    background: ${primaryColor.hex()};
    border: 1px double ${primaryColor.hex()};
    color: white;
  }
  .CalendarDay__selected:hover {
    background: ${primaryColor.hex()};
    color: white;
  }
  .CalendarDay__hovered_span:hover,
  .CalendarDay__hovered_span {
    background: ${primaryColor.lighten(0.25).hex()};
    border: 1px double ${primaryColor.lighten(0.15).hex()};
    color: #fff;
  }

  .SingleDatePickerInput {
    border: none;
  }

  .DateInput_input {
    padding: 8px;
    border: solid 1px ${constants.COLORS.divider};
    border-radius: 3px;
  }
`

export default dayPickerCustomStyle
